import { Controller } from '@hotwired/stimulus'
import Highcharts from 'highcharts'
import HighchartsMoreFn from 'highcharts/highcharts-more'
import HighchartsAccessibilityFn from 'highcharts/modules/accessibility'
HighchartsMoreFn(Highcharts)
HighchartsAccessibilityFn(Highcharts)

// Connects to data-controller="return-stdevy-point-chart"
export default class extends Controller {
  static targets = [
    'distributionChart',
    'categoryTab',
  ]
  static values = {
    idFund: String,
    page: String,
    isMobile: Boolean,
    chartData: Object,
    height: String,
    dataId: String
  }
  connect() {
    this.returnStdevyPointChartData()
  }

  async returnStdevyPointChartData() {
    if (this.pageValue == 'theme' || this.pageValue == 'function') {
      let url = '/searching/result_map_json'
      let data = new FormData()
      data.append('search_type', this.pageValue)
      data.append('data', this.dataIdValue)
      data.append(
        'authenticity_token',
        document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      )
      await fetch(url, { method: 'POST', body: data })
        .then((Result) => Result.json())
        .then((dataValue) => {
          this.chartDataValue = dataValue
          this.returnStdevyPointChartInit()
        })
        .catch((errorMsg) => {
          console.log(errorMsg)
        })
    } else {
      let url = ''
      if (this.pageValue == 'fund') {
        url = '/json/funds/' + this.idFundValue + '/get_class_json_data'
      } else {
        url = '/json/search_' + this.pageValue + '.json'
      }
      await fetch(url + '?time=' + new Date().getTime(), { method: 'GET' })
        .then((Result) => Result.json())
        .then((dataValue) => {
          this.chartDataValue = dataValue
          this.returnStdevyPointChartInit()
        })
        .catch((errorMsg) => {
          console.log(errorMsg)
        })
    }
  }

  returnStdevyPointChartInit() {
    if (this.hasCategoryTabTarget) {
      if (
        this.categoryTabTarget.querySelectorAll(
          "input[type='radio'][name='category-size']:checked",
        ).length === 0
      ) {
        let chartCategory = this.categoryTabTarget.querySelectorAll(
          "input[type='radio'][name='category-size']",
        )
        chartCategory.forEach((category, idx) => {
          if (idx == 0) {
            category.checked = true
            this.categoryTabTarget
              .querySelectorAll('label')
              [idx].classList.add('text-white', 'bg-[#ed6d34]')
            this.categoryTabTarget
              .querySelectorAll('label')
              [idx].classList.remove('bg-[#f9f8f8]')
          }
        })
        this.drawChart(chartCategory[0].value)
      }
    } else {
      this.drawChart('large')
    }
  }

  // 大分類 中分類 小分類 的按鈕切換
  categoryChartChange() {
    this.categoryTabTarget
      .querySelectorAll("input[type='radio'][name='category-size']")
      .forEach((input, idx) => {
        let labelByInput = this.categoryTabTarget.querySelectorAll('label')[idx]
        if (input.checked) {
          labelByInput.classList.remove('bg-[#f9f8f8]')
          labelByInput.classList.add('text-white', 'bg-[#ed6d34]')
          // 更新chart by 按鈕大小
          this.drawChart(input.value)
        } else {
          labelByInput.classList.remove('text-white', 'bg-[#ed6d34]')
          labelByInput.classList.add('bg-[#f9f8f8]')
        }
      })
  }

  chartStockData(type) {
    let newChartData = this.deepCopy(this.chartDataValue.data)
    let stockData = new Array()
    for (let i in newChartData) {
      if (type == i) {
        let chartDataAry = newChartData[i].concat()
        for (let j = 0; j < newChartData[i].length; j++) {
          stockData[j] = chartDataAry[j]
        }
        for (let k = 0; k < stockData.length; k++) {
          stockData[k].data = [
            [parseFloat(stockData[k].x), parseFloat(stockData[k].y)],
          ]
          delete stockData[k].x
          delete stockData[k].y
          if (stockData[k].type == 1) {
            stockData[k].color = 'rgba(221,20,20,1)'
            stockData[k].marker = { symbol: 'url(/images/point.png)' }
          } else if (stockData[k].type == 2) {
            stockData[k].color = 'rgba(221,20,20,1)'
            stockData[k].marker = { symbol: 'cross' }
            stockData[k].dataLabels = { y: 0 }
          } else {
            stockData[k].color = 'rgba(43,93,234,1)'
            stockData[k].marker = { symbol: 'cross' }
            stockData[k].dataLabels = { enabled: false }
          }
          delete stockData[k].type
        }
      }
    }
    let diff = this.chartDataValue.data.small.length - stockData.length
    if (diff > 0) {
      for (let i = 0; i < diff; i++) {
        stockData.push({})
      }
    }
    return stockData
  }

  drawChart(type) {
    const page = this.pageValue
    const chartData = this.chartDataValue
    this.chart = Highcharts.chart(this.distributionChartTarget, {
      chart: {
        type: 'scatter',
        zoomType: 'xy',
        backgroundColor: '#fff',
        borderRadius: 5,
        borderWidth: 1,
        borderColor: '#dcdcdc',
        height: this.heightValue,
      },
      title: {
        text: null,
      },
      subtitle: {},
      xAxis: {
        maxPadding: 0.2,
        gridLineWidth: 1,
        gridLineColor: '#dcdcdc',
        gridLineDashStyle: 'Dash',
        title: {
          text: null,
        },
        lineColor: '#ccd6eb',
        tickColor: '#ccd6eb',
        labels: {
          style: {
            color: '#666666',
            fontSize: '11px',
          },
        },
      },
      yAxis: {
        gridLineWidth: 1,
        gridLineColor: '#dcdcdc',
        gridLineDashStyle: 'Dash',
        title: {
          text: null,
        },
        labels: {
          style: {
            color: '#666666',
            fontSize: '11px',
          },
          padding: 1,
        },
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        useHTML: true,
        borderWidth: 1,
        formatter: function () {
          return (
            '<span style="display: inline-block; width: 6px; height: 6px; border-radius: 50%; vertical-align: top; margin:6px 3px 0 0 ; background:' +
            this.point.color +
            '"></span>' +
            this.series.name +
            '<br/><span style="font-size: 10px">リターン:</span> ' +
            '<b style="font-size: 10px">' +
            this.point.y.toFixed(2) +
            '</b>' +
            '<br/><span style="font-size: 10px">リスク:</span> ' +
            '<b style="font-size: 10px">' +
            this.point.x.toFixed(2) +
            '</b>'
          )
        },
      },
      plotOptions: {
        series: {
          dataLabels: {
            enabled: true,
            y: -5,
            style: {
              width: this.isMobileValue ? '200px' : '500px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              fontSize: '13px',
              fontWeight: 'normal',
            },
            formatter: function () {
              return this.series.name
            },
          },
          events: {
            click: async function (e) {
              if (e.point.series.symbol == "cross") {
                let pointName = e.point.series.name;
                if (page == "fund") {
                  // TODO: production 是壞的狀況下，要確認是否還需要這個功能
                  // fund show
                  // if (pointName.indexOf("単位型") == -1) {
                  //   await fetch("/ranking/set_ranking_conds?type=" + type + "&class_name=" + encodeURI(e.point.series.name),
                  //   { method: "GET" })
                  //     .then((Result) => Result.json())
                  //     .then((data) => {
                  //       if (data.status == 1) {
                  //         window.location.href =
                  //           "/ranking/<%= FundRanking::CATEGORY_SHARP %>";
                  //       }
                  //     })
                  //     .catch((_errorMsg) => {
                  //       console.log("エラーが発生しました");
                  //     });
                  // }
                } else if (page == "theme" || "function") {
                  // search result
                  for (let i = 0; i < chartData.id_list.length; i++) {
                    let fund = chartData.id_list[i];
                    if (fund.name == pointName) {
                      window.location.href = "/fund/" + fund.id;
                      break;
                    }
                  }
                } else {
                  // search type IN (theme, function)
                  // TODO: 在 params action is theme， click圖表上的圓圈時會換到 theme/：type的頁面
                  // document.querySelector(".theme_list .theme_name").forEach((item) => {
                  //   if (item.innerHtml == pointName) {
                  //     item.click()
                  //   }
                  // });
                }
              }
            },
          },
          states: {
            inactive: {
              opacity: 1,
            },
          },
        },
      },
      series: this.chartStockData(type), // Set chart point data to Highchart
      credits: {
        enabled: false, //不显示LOGO
      },
    })
  }

  deepCopy(p, cp) {
    let c = cp || {}
    for (let i in p) {
      if (typeof p[i] === 'object') {
        c[i] = p[i].constructor === Array ? [] : {}
        this.deepCopy(p[i], c[i])
      } else {
        c[i] = p[i]
      }
    }
    return c
  }
}
